import { render, staticRenderFns } from "./videoflowbag.vue?vue&type=template&id=2a277934&lang=pug&"
import script from "./videoflowbag.vue?vue&type=script&lang=js&"
export * from "./videoflowbag.vue?vue&type=script&lang=js&"
import style0 from "./videoflowbag.vue?vue&type=style&index=0&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports